import { Injectable, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class GeoCoordinatorPLCIdentifierService {
    private readonly deviceService = inject(DeviceService);

    get identifier(): string {
        if (this.deviceService.isTouch) {
            if (this.deviceService.isiOS) {
                return 'oobeeiOS';
            }
            return 'oobeeAndroid';
        }
        return 'geocomply';
    }
}
